module.exports = __webpack_public_path__ + "assets/12176882db5b0e73980a717e8b8fbbab.svg";